const controllers = new Map();
const favoritesKey = 'bonjoer-pstr-favorites-v1';
let favorites = [];
try {
  const saved = JSON.parse(localStorage.getItem(favoritesKey) || '[]');
  if (Array.isArray(saved)) favorites = saved.filter(item => item && /^\d+$/.test(String(item.id)) && typeof item.url === 'string' && item.url.startsWith('/products/')).slice(0, 100);
} catch {}
let persistedFavorites = JSON.stringify(favorites);
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

function updateFavorites() {
  const favoriteIds = new Set(favorites.map(item => item.id));
  document.querySelectorAll('[data-pstr-favorite]').forEach(button => {
    const active = favoriteIds.has(button.dataset.pstrFavorite);
    button.setAttribute('aria-pressed', String(active));
    const label = active ? button.dataset.labelRemove : button.dataset.labelAdd;
    if (label) { button.setAttribute('aria-label', label); button.title = label; }
  });
  document.querySelectorAll('[data-pstr-favorites-count]').forEach(count => {
    count.textContent = String(favorites.length);
    count.hidden = favorites.length === 0;
  });
  const serialized = JSON.stringify(favorites);
  if (serialized !== persistedFavorites) {
    try { localStorage.setItem(favoritesKey, serialized); persistedFavorites = serialized; } catch {}
  }
}

function renderFavorites() {
  const dialog = document.querySelector('[data-pstr-favorites]');
  const list = dialog?.querySelector('[data-pstr-favorites-list]');
  if (!list) return;
  list.replaceChildren();
  if (!favorites.length) {
    const empty = document.createElement('p');
    empty.textContent = dialog.dataset.empty;
    list.append(empty);
    return;
  }
  for (const item of favorites) {
    const row = document.createElement('article');
    row.className = 'pstr-saved-item';
    const media = document.createElement('a');
    media.href = item.url;
    const image = document.createElement('img');
    try {
      const url = new URL(item.image, location.origin);
      if (url.protocol === 'https:' && (url.origin === location.origin || url.hostname === 'cdn.shopify.com')) image.src = url.href;
    } catch {}
    image.alt = item.title;
    image.loading = 'lazy';
    image.width = 72;
    image.height = 90;
    media.append(image);
    const content = document.createElement('div');
    const title = document.createElement('h3');
    const link = document.createElement('a');
    link.href = item.url;
    link.textContent = item.title;
    title.append(link);
    const price = document.createElement('p');
    price.textContent = item.price;
    content.append(title, price);
    const remove = document.createElement('button');
    remove.type = 'button';
    remove.dataset.pstrRemoveFavorite = item.id;
    remove.textContent = '×';
    remove.setAttribute('aria-label', `${dialog.dataset.remove}: ${item.title}`);
    remove.title = remove.getAttribute('aria-label');
    row.append(media, content, remove);
    list.append(row);
  }
}

function openDialog(dialog, trigger) {
  if (!(dialog instanceof HTMLDialogElement) || dialog.open) return;
  dialog.pstrTrigger = trigger;
  dialog.showModal();
  trigger?.setAttribute('aria-expanded', 'true');
}

function initialize(root = document) {
  root.querySelectorAll('[data-pstr-track]').forEach(track => {
    if (controllers.has(track)) return;
    const abort = new AbortController();
    const buttons = [...document.querySelectorAll('[data-pstr-scroll]')].filter(button => button.getAttribute('aria-controls') === track.id);
    let frame = 0;
    const sync = () => {
      frame = 0;
      buttons.forEach(button => {
        const atStart = track.scrollLeft < 3;
        const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 3;
        button.disabled = Number(button.dataset.pstrScroll) < 0 ? atStart : atEnd;
      });
    };
    const update = () => { if (!frame) frame = requestAnimationFrame(sync); };
    track.addEventListener('scroll', update, { passive: true, signal: abort.signal });
    track.addEventListener('keydown', event => {
      if (event.target !== track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      track.scrollBy({ left: track.clientWidth * (event.key === 'ArrowLeft' ? -1 : 1), behavior: reducedMotion.matches ? 'instant' : 'smooth' });
    }, { signal: abort.signal });
    const observer = new ResizeObserver(update);
    observer.observe(track);
    controllers.set(track, () => { abort.abort(); observer.disconnect(); cancelAnimationFrame(frame); });
    update();
  });
  root.querySelectorAll('.pstr-dialog').forEach(dialog => {
    if (controllers.has(dialog)) return;
    const abort = new AbortController();
    dialog.addEventListener('close', () => {
      dialog.pstrTrigger?.setAttribute('aria-expanded', 'false');
      dialog.pstrTrigger?.focus();
    }, { signal: abort.signal });
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    }, { signal: abort.signal });
    controllers.set(dialog, () => { abort.abort(); if (dialog.open) dialog.close(); });
  });
  root.querySelectorAll('[data-pstr-header]').forEach(header => {
    if (controllers.has(header)) return;
    let lastHeight = '';
    const measure = () => {
      const announcement = header.querySelector('.pstr-announcement')?.offsetHeight || 0;
      const main = header.querySelector('.pstr-header')?.offsetHeight || 0;
      const height = `${announcement}:${main}`;
      if (height === lastHeight) return;
      lastHeight = height;
      document.body.style.setProperty('--pstr-announcement-height', `${announcement}px`);
      document.body.style.setProperty('--header-height', `${main}px`);
      document.body.style.setProperty('--header-group-height', `${main + announcement}px`);
    };
    const observer = new ResizeObserver(measure);
    observer.observe(header);
    controllers.set(header, () => observer.disconnect());
    measure();
  });
  root.querySelectorAll('.pstr-footer__menu').forEach(menu => {
    if (controllers.has(menu)) return;
    const desktop = window.matchMedia('(min-width: 750px)');
    const sync = () => { menu.open = desktop.matches; };
    desktop.addEventListener('change', sync);
    controllers.set(menu, () => desktop.removeEventListener('change', sync));
    sync();
  });
  root.querySelectorAll('.pstr-autoplay-video').forEach(video => {
    if (controllers.has(video)) return;
    const abort = new AbortController();
    let visible = false;
    let loaded = false;
    const sync = () => {
      if (!visible || document.hidden) { video.pause(); return; }
      if (!loaded) {
        video.querySelectorAll('source[data-pstr-video-src]').forEach(source => {
          source.src = source.dataset.pstrVideoSrc;
          source.removeAttribute('data-pstr-video-src');
        });
        loaded = true;
        video.load();
      }
      video.controls = reducedMotion.matches;
      if (reducedMotion.matches) video.pause();
      else video.play().catch(() => { video.controls = true; });
    };
    const observer = new IntersectionObserver(entries => {
      visible = entries[0].isIntersecting;
      sync();
    }, { threshold: 0.15 });
    observer.observe(video);
    document.addEventListener('visibilitychange', sync, { signal: abort.signal });
    reducedMotion.addEventListener('change', sync, { signal: abort.signal });
    controllers.set(video, () => { abort.abort(); observer.disconnect(); video.pause(); });
  });
  updateFavorites();
}

// Secondary product media is only requested when a customer explores a card.
function loadHoverMedia(event) {
  if (!(event.target instanceof Element)) return;
  if (event.type === 'pointerover' && event.pointerType !== 'mouse') return;
  const card = event.target.closest('.pstr-card__media');
  const picture = card?.querySelector('picture[data-pstr-hover]');
  const source = picture?.querySelector('source[data-pstr-hover-srcset]');
  const image = picture?.querySelector('img');
  if (!source || !image || !window.matchMedia(source.media).matches) return;
  const ready = () => {
    if (!image.currentSrc.startsWith('data:') && image.naturalWidth > 1) {
      picture.setAttribute('data-pstr-hover-ready', '');
      image.removeEventListener('load', ready);
    }
  };
  image.addEventListener('load', ready);
  image.addEventListener('error', () => image.removeEventListener('load', ready), { once: true });
  source.srcset = source.dataset.pstrHoverSrcset;
  source.removeAttribute('data-pstr-hover-srcset');
  if (image.complete) ready();
}
document.addEventListener('pointerover', loadHoverMedia, { passive: true });
document.addEventListener('focusin', loadHoverMedia);

document.addEventListener('click', event => {
  if (!(event.target instanceof Element)) return;
  const trigger = event.target.closest('button, a');
  if (!trigger) return;
  if (trigger.matches('[data-pstr-favorite]')) {
    const id = trigger.dataset.pstrFavorite;
    const index = favorites.findIndex(item => item.id === id);
    if (index >= 0) favorites.splice(index, 1);
    else favorites.push({ id, title: trigger.dataset.title, url: trigger.dataset.url, image: trigger.dataset.image, price: trigger.dataset.price });
    favorites = favorites.slice(-100);
    updateFavorites();
    const status = document.querySelector('[data-pstr-status]');
    if (status) status.textContent = index >= 0 ? status.dataset.removed : status.dataset.added;
  } else if (trigger.matches('[data-pstr-open-favorites]')) {
    renderFavorites();
    openDialog(document.querySelector('[data-pstr-favorites]'), trigger);
  } else if (trigger.matches('[data-pstr-remove-favorite]')) {
    favorites = favorites.filter(item => item.id !== trigger.dataset.pstrRemoveFavorite);
    updateFavorites();
    renderFavorites();
    document.querySelector('[data-pstr-favorites] [data-pstr-close]')?.focus();
  } else if (trigger.matches('[data-pstr-open-menu]')) {
    openDialog(document.getElementById(trigger.getAttribute('aria-controls')), trigger);
  } else if (trigger.matches('[data-pstr-lightbox]')) {
    openDialog(document.getElementById(trigger.dataset.pstrLightbox), trigger);
  } else if (trigger.matches('[data-pstr-close]')) {
    trigger.closest('dialog')?.close();
  } else if (trigger.matches('[data-pstr-scroll]')) {
    const track = document.getElementById(trigger.getAttribute('aria-controls'));
    if (track) track.scrollBy({ left: (track.clientWidth + 16) * Number(trigger.dataset.pstrScroll), behavior: reducedMotion.matches ? 'instant' : 'smooth' });
  }
});

document.addEventListener('toggle', event => {
  const target = event.target;
  if (!(target instanceof HTMLDetailsElement) || !target.classList.contains('pstr-mega') || !target.open) return;
  document.querySelectorAll('.pstr-mega[open]').forEach(menu => { if (menu !== target) menu.open = false; });
}, true);
document.addEventListener('click', event => {
  if (!(event.target instanceof Element) || event.target.closest('.pstr-mega')) return;
  document.querySelectorAll('.pstr-mega[open]').forEach(menu => { menu.open = false; });
});
document.addEventListener('keydown', event => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.pstr-mega[open]').forEach(menu => { menu.open = false; menu.querySelector('summary')?.focus(); });
});
document.addEventListener('shopify:section:load', event => initialize(event.target));
document.addEventListener('shopify:section:unload', event => {
  for (const [element, cleanup] of controllers) {
    if (event.target.contains(element)) { cleanup(); controllers.delete(element); }
  }
});
document.addEventListener('shopify:block:select', event => {
  const slide = event.target.closest('.pstr-hero__slide');
  if (slide) slide.parentElement.scrollTo({ left: slide.offsetLeft, behavior: 'instant' });
  const track = event.target.closest('[data-pstr-track]');
  if (track && !slide) track.scrollTo({ left: event.target.offsetLeft - track.offsetLeft, behavior: 'instant' });
});
initialize();
